import { IEdge } from './IEdge';
import { Condition } from './Condition';
import { OptionalText } from './OptionalText';
import { AnswerMap } from '../AnswerMap';

export class Edge {
  id: string | string[];

  text: string;

  optionalText: OptionalText[];

  description: string;

  optionalDescription: OptionalText[];

  next: string;

  excludes: string[];

  invalidates: string[];

  condition: Condition | null = null;

  constructor(sourceEdge: IEdge) {
    this.id = sourceEdge.id;
    this.text = sourceEdge.text;
    this.optionalText = OptionalText.convertArray(sourceEdge.optionalText);
    this.description = sourceEdge.description;
    this.optionalDescription = OptionalText.convertArray(sourceEdge.optionalDescription);
    this.next = sourceEdge.next;
    this.excludes = sourceEdge.excludes;
    this.invalidates = sourceEdge.invalidates;

    if (sourceEdge.condition) {
      this.condition = new Condition(sourceEdge.condition, sourceEdge.orCondition);
    }
  }

  public static convertArray(sourceEdges: IEdge[]): Edge[] {
    const edgeArray: Edge[] = [];
    sourceEdges.forEach((element) => {
      edgeArray.push(new Edge(element));
    });

    return edgeArray;
  }

  public getText(settings: AnswerMap): string {
    return OptionalText.evaluateOptionalText(settings, this.optionalText, this.text);
  }

  public getDescription(settings: AnswerMap): string {
    return OptionalText.evaluateOptionalText(settings, this.optionalDescription, this.description);
  }

  public evaluateCondition(answers: AnswerMap): boolean {
    if (!this.condition) {
      return true;
    }

    return this.condition.evaluate(answers);
  }
}

export default Edge;
